<template>
  <span v-tooltip.top="tooltipSetup" :class="props.customStyle">
    <img alt="globe icon" src="/images/icon-globe-google-fonts.svg" :class="props.iconStyle" />
  </span>
</template>

<script setup>
import Tooltip from "primevue/tooltip";

const props = defineProps({
  productType: {
    type: String,
    required: true,
  },
  customStyle: {
    type: String,
    required: false,
    default: "inline-block",
  },
  iconStyle: {
    type: String,
    required: false,
    default: "h-[1.125rem] w-[1.125rem]",
  },
});

// Adding new directive v-tooltip
const vTooltip = Tooltip;

const tooltipSetup = {
  value: `This ${props.productType} is shared within the APIConnect Marketplace.`,
  id: "duration-tooltip",
  class: "bg-white max-w-xs shaddow rounded white",
  hideDelay: "0.3",
  pt: {
    text: "text-black text-sm font-extralight p-3 leading-none",
  },
};
</script>
